import getComparison from 'components/V5Gadget/Matrix/getComparison';
import { SortType } from './types';

const percentDeltaSort = (
  isIgnoreWinningOrLosing: boolean,
  a: SortType,
  b: SortType,
) => {
  const { delta: deltaA, isGood: isGoodA } = getComparison({
    value: a.value,
    previous: a.previous,
    formatting: a.formatting,
    type: a.type,
  });
  const { delta: deltaB, isGood: isGoodB } = getComparison({
    value: b.value,
    previous: b.previous,
    formatting: b.formatting,
    type: b.type,
  });

  if (a.previous === 0 && b.previous === 0) {
    return 0; // do nothing
  }

  if (a.previous === 0 || b.previous === 0) {
    // -1 => a comes first
    // +1 => b comes first

    if (isIgnoreWinningOrLosing) {
      // We only care about the amount of movement
      if (a.previous === 0) {
        return -1;
      }
      if (b.previous === 0) {
        return 1;
      }
    } else {
      // We care about winners and losers
      if (a.previous === 0) {
        if (isGoodB) {
          return -1;
        } else {
          return 1;
        }
      }
      if (b.previous === 0) {
        if (isGoodA) {
          return 1;
        } else {
          return -1;
        }
      }
    }
  } else {
    if (isIgnoreWinningOrLosing) {
      return Math.abs(deltaA) - Math.abs(deltaB);
    } else {
      return deltaA - deltaB;
    }
  }
};

export default percentDeltaSort;
